export const accountComponents = {
  // OtaLinksBar.vue — OTA links bar
  otaLinks: {
    copied: "Copied!",
    copy: "Copy",
    edit: "Edit",
    remove: "Remove",
    addLink: "OTA link",
    modalEyebrow: "Listing link on the OTA",
    modalEyebrowUnit: "This unit's link on the OTA",
    editTitle: "Edit link",
    addTitle: "Add OTA link",
    modalHint: "Paste the public URL of <b>this listing</b> on the OTA. It lets you copy and open it quickly.",
    urlLabel: "Listing URL",
    cancel: "Cancel",
    saving: "Saving…",
    save: "Save link",
    saveError: "Couldn't save the link. Check the URL.",
    fromListing: "from listing",
    inheritedNote: "This is the listing's link. Until this unit has its own, this is the one we send.",
    override: "Set its own",
    modalHintUnit: "Paste the public URL of <b>this unit</b> on the OTA. If you set it, this one is sent; if you leave it empty, the listing's is sent.",
  },

  // GuestJourneySimulator.vue — guest journey simulator
  journeySim: {
    title: "Simulate the guest journey",
    badge: "Test",
    intro: "Replay the whole process —from booking to review— in a WhatsApp chat. Enter a name and a number and hit <strong>play</strong>. If you turn on «Send to mobile», every message is really sent to the number so you can try it and chat with the AI Agent.",
    guestNameLabel: "Guest name",
    guestNamePlaceholder: "e.g. Laura García",
    phoneLabel: "WhatsApp number (for testing)",
    phoneHint: "International format, e.g. +34 600123456",
    toggleTitle: "Also send to mobile",
    toggleDesc: "Each step is really sent to the number above",
    warn: "First send «hi» to the number from your phone to open WhatsApp's 24h window; that way you'll receive the messages instantly.",
    reset: "Restart",
    prev: "Previous",
    pause: "Pause",
    play: "Play",
    continue: "Continue",
    next: "Next",
    stepProgress: "Step {current} of {total}",
    guestFallback: "Guest",
    propertyFallback: "your accommodation",
    testNumberFallback: "test number",
    dayLabel: "Guest journey",
    loadingMsgs: "Loading your messages…",
    pressPlay: "Press <strong>Play</strong> to start the journey ▶",
    hintSending: "Live sending on · each step reaches {phone}",
    hintSimulated: "Simulated view · turn on «Send to mobile» to test on a real phone",
    toastInvalidPhone: "Enter a valid WhatsApp number to send to mobile.",
    toastSendFailed: "Couldn't send.",
    toastSendMobileFailed: "Couldn't send to mobile.",
    // Simulated WhatsApp messages ({{...}} are resolved by resolve())
    msgConfirmation: "Hi *{{nombre_huesped}}* 👋\n\nYour booking at *{{nombre_alojamiento}}* is confirmed ✅\n\nBooking code: *6233Q1VC5*\nDates: *{{fecha_entrada}}* – *{{fecha_salida}}* 📅\n\nThrough this WhatsApp you can request your online check-in link and receive the arrival instructions.",
    msgCheckinPrompt: "*Hi* 👋 I'm the virtual assistant of *{{nombre_alojamiento}}*.\n\nPress *Ok* to continue with your check-in.",
    msgChooseLanguage: "Elige tu idioma · Choose your language",
    msgCheckinLink: "*Thanks* 👋 Here's your link to do the check-in 😎\n\nhttps://guest.wacheckin.com/checkin/6233Q1VC5",
    msgWelcome: "👋 Welcome to *{{nombre_alojamiento}}*, {{nombre_huesped}}!\n\nThank you for completing your registration. Here's all the information about your stay.",
    msgAccess: "🔒🔑 *Access code · {{nombre_alojamiento}}*\n\nYour code is: *58117*\n\nValid throughout your stay.",
    msgArrival: "🏡 *Arrival instructions*\n\nOn arrival, head to the main entrance and enter your code on the lock. 🔑\n\nEnjoy your stay! ✨",
    msgGuestCheckout: "Hi, what time is check-out?",
    msgCheckoutReply: "Hi there! Check-out is until *12:00* 🕚 If you need to leave later, I can look into a late check-out for you 😊",
    msgCheckout: "Hi *{{nombre_huesped}}* 👋\n\nJust a reminder that *your stay ends tomorrow* at *{{nombre_alojamiento}}*.\n\n🕚 The latest check-out time is *{{hora_salida}}*.\n\nThank you so much for your visit and safe travels! 😊",
    msgReview: "⭐ How was your stay at *{{nombre_alojamiento}}*, {{nombre_huesped}}?\n\nWe'd love to hear your feedback. Leave us your review here 👉 https://g.page/r/review",
  },

  // GuestJourneyTimeline.vue — guest journey timeline
  journeyTimeline: {
    title: "Guest journey",
    subtitle: "From booking to departure. Hover over each event to see the message.",
    disabled: "Disabled",
    clickToConfigure: "Click to configure",
    nameFallback: "your accommodation",
    // Node labels
    labelLead: "Booking / Lead",
    labelConfirm: "Confirmation",
    labelCheckinLink: "Check-in link",
    labelWelcome: "Welcome",
    labelAccess: "Access / Lock",
    labelArrival: "Arrival instructions",
    labelCheckout: "Departure message",
    labelReview: "Review",
    // Timing of each node
    whenLead: "On booking or messaging",
    whenConfirm: "Booking confirmed",
    whenCheckinLink: "Before arrival",
    whenWelcome: "After registration",
    whenAccess: "Arrival day",
    whenArrival: "Arrival day",
    whenCheckout: "Eve of checkout",
    whenReview: "After checkout",
    // WhatsApp previews
    previewLead: "👋 Hi there! I'm the virtual assistant of *{name}*.\n\nI'm here to help with your booking and answer any questions.",
    previewConfirm: "Hi *Laura García* 👋\n\nYour booking at *{name}* is confirmed ✅\n\nBooking code: *6233Q1VC5*\nDates: *05/06/2026* – *07/06/2026* 📅\n\nThrough this WhatsApp you can request your online check-in link and also receive the arrival instructions.\nIf you need help before or during your stay, message us here 💬",
    previewWelcome: "👋 Welcome to *{name}*!\n\nThank you for completing your registration. Here's all the information about your stay.",
    previewAccess: "🔒🔑 *Access code · {name}*\n\nYour code is: *58117*\n\nValid throughout your stay.",
    previewArrival: "🏡 *Arrival instructions*\n\nOn arrival, head to the main entrance of the accommodation. 🔑\n\nEnjoy your stay! ✨",
    previewCheckout: "Hi 👋\n\nJust a reminder that *your stay ends tomorrow* at *{name}*.\n\n🕚 The latest check-out time is *12:00*.\n\nSafe travels! 😊",
    previewReview: "⭐ How was your stay at *{name}*?\n\nWe'd love to hear your feedback. Leave us your review here 👉 …",
    previewLeadNoWaba: "📲 *Activate your AI Agent* to handle new bookings over WhatsApp by connecting your own number.\n\nThat way the assistant will reply to people who aren't customers yet, answering questions about your accommodations and guiding them toward booking.",
    // Full "Check-in link" conversation
    chatCheckinAgent1: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{name}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
    chatChooseLanguage: "Elige tu idioma · Choose your language",
    chatCheckinLink: "*Thanks* 👋 Here's your link to do the Check-In. 😎\n\nhttps://guest.wacheckin.com/…",
    // Access messages (locks)
    lockLabelFallback: "Entrance",
    lockDynamic: "🔒🔑 *{label} · {name}*\n\nYour access code is: *58117*\n\nValid throughout your stay.",
    lockNone: "🔑 *{label} · {name}*\n\nThe key box opens with the code: *{code}*\n\nInside you'll find the keys to the accommodation.",
    lockDefault: "🔒🔑 *{label} · {name}*\n\nThe lock code is: *{code}*\n\nUse it to open the door.",
    // Departure message (fallback)
    checkoutFallback: "Hi, *María* 👋\n\nJust a reminder that your stay ends tomorrow at *{name}*.\n\n🕚 The latest check-out time is *{time}*.\n\nThank you so much for your stay. Safe travels! 😊",
  },

  // ListingIcalPanel.vue — iCal sync panel
  icalPanel: {
    eyebrow: "iCal Calendar",
    heading: "iCal Synchronization",
    pageDesc: "Export your bookings to other platforms and import external calendars to automatically block dates on your listing.",
    loading: "Loading configuration…",
    exportLabel: "Your iCal link (export)",
    exportDesc: "Copy this link and paste it into Airbnb, Booking.com, or any platform that supports iCal sync. They'll pull your bookings automatically.",
    copied: "Copied",
    copy: "Copy",
    tipAllUnits: "This link includes the bookings of <strong>all units</strong> of the listing.",
    tipHotelRooms: "Each <strong>physical room</strong> has its own link. Connect it in Airbnb/Booking for that specific room and only THAT room's bookings will be exported.",
    importLabel: "External calendars (import)",
    syncing: "Syncing…",
    syncAll: "Sync all",
    importDesc: "Paste the iCal URLs from your other platforms (Airbnb, Booking.com, etc.) and Wacheckin will automatically block those dates on your calendar.",
    lastSync: "Last sync: {date}",
    delete: "Delete",
    empty: "You don't have any external calendars linked yet.",
    addExternal: "Add external calendar",
    newExternal: "New external calendar",
    nameLabel: "Calendar name",
    namePlaceholder: "e.g. Airbnb - Apt 1",
    physicalRoom: "Physical room",
    listingUnit: "Listing unit",
    selectRoomPlaceholder: "Select a room…",
    selectUnitPlaceholder: "Select a unit…",
    urlLabel: "iCal calendar URL",
    cancel: "Cancel",
    saving: "Saving…",
    saveSync: "Save and sync",
    defaultGroup: "Rooms",
    toastLoadError: "Couldn't load the iCal configuration.",
    toastSelectUnit: "Select a room / unit.",
    toastAdded: "Calendar added and synced successfully.",
    toastAddError: "Error adding the calendar.",
    deleteConfirm: 'Delete "{name}" and all its blocked bookings?',
    toastDeleted: "Calendar deleted.",
    toastDeleteError: "Couldn't delete the calendar.",
    toastSyncError: "Error syncing.",
  },

  // ListingIcalModal.vue — iCal sync modal
  icalModal: {
    title: "iCal Synchronization",
    loading: "Loading configuration…",
    exportLabel: "Your iCal link (export)",
    exportDesc: "Copy this link and paste it into Airbnb, Booking.com, or any platform that supports iCal sync. They'll pull your bookings automatically.",
    copied: "Copied",
    copy: "Copy",
    tipAllUnits: "This link includes the bookings of <strong>all units</strong> of the listing.",
    tipHotelRooms: "Each <strong>physical room</strong> has its own link. Connect it in Airbnb/Booking for that specific room and only THAT room's bookings will be exported.",
    importLabel: "External calendars (import)",
    syncing: "Syncing…",
    syncAll: "Sync all",
    importDesc: "Paste the iCal URLs from your other platforms (Airbnb, Booking.com, etc.) and Wacheckin will automatically block those dates on your calendar.",
    lastSync: "Last sync: {date}",
    delete: "Delete",
    empty: "You don't have any external calendars linked yet.",
    addExternal: "Add external calendar",
    newExternal: "New external calendar",
    nameLabel: "Calendar name",
    namePlaceholder: "e.g. Airbnb - Apt 1",
    physicalRoom: "Physical room",
    listingUnit: "Listing unit",
    selectRoomPlaceholder: "Select a room…",
    selectUnitPlaceholder: "Select a unit…",
    urlLabel: "iCal calendar URL",
    cancel: "Cancel",
    saveSync: "Save and sync",
    defaultGroup: "Rooms",
    toastLoadError: "Couldn't load the iCal configuration.",
    toastSelectUnit: "Select a room / unit.",
    toastAdded: "Calendar added and synced successfully.",
    toastAddError: "Error adding the calendar.",
    deleteConfirm: 'Delete "{name}" and all its blocked bookings?',
    toastDeleted: "Calendar deleted.",
    toastDeleteError: "Couldn't delete the calendar.",
    toastSyncError: "Error syncing.",
  },
};
